const func = ($target) => {
    var $cardSwiper = $target.find(".single-card-slider-wrap"),
        $singleCard = $('.single-card');
    window.loader.key("swiper", function () {
        $singleCard.removeClass('col-md-4')
        var swiper = new Swiper($cardSwiper, {
            slidesPerView: 3,
            loop:false,
            preloadImages: false,
            simulateTouch: false,
            navigation: {
                nextEl: $target.find(".swiper-button-next"),
                prevEl: $target.find(".swiper-button-prev"),
            },
            breakpoints: {
                991:{
                    slidesPerView:2,
                },
                650:{
                    slidesPerView:1,
                },
            }
        });
    });
}
export default func;
